import {
    ComponentManager,
    DataTransferObject,
    FrontController,
    RADApplication
} from "radpresentation.htmlclient.defaultviewextensions";
import { IWorkflowExecutionLinkContainerDTO } from '#/WorkflowEngineInterfaces';

export default class WorkflowUtility {

    public static startWorkflow(name: string): void {
        const pdoId = WorkflowUtility.getWorkflowId(name);
        if (pdoId === null) {
            console.error('Workflow ' + name + ' not found.');
            return;
        }

        this.startWorkflowWithPdoId(pdoId);
    }

    public static startWorkflowWithPdoId(pdoId: any): void {
        FrontController.managedCallStaticOperation('WFE.WorkflowEngine.Model.PDWorkflowMeta', 'StartNewInstance', [pdoId], {}, null, null, true);
    }

    public static getWorkflowContainerDto(): IWorkflowExecutionLinkContainerDTO {
        const additionalLoginInformation = RADApplication.getInstance().user.additionalLoginInformation();
        const xml = additionalLoginInformation['WorkflowLinkSpecifications'];
        return DataTransferObject.parseFromXML(xml) as any;
    }

    private static getWorkflowId(name: string): string {
        const dto = WorkflowUtility.getWorkflowContainerDto();
        if (!dto)
            return null;

        for (let link of dto.Links) {
            if (link.Path + '.' + link.Name === name)
                return link.PDWorkflowMetaPDO_ID;
        }

        return null;
    }
}

ComponentManager.setUtility('WorkflowUtility', WorkflowUtility, 'WorkflowEngineHTMLViewExtension');